<template>
    <ColumnaIzquierda></ColumnaIzquierda>
    <GenerarContenido></GenerarContenido>
</template>
<script>
import ColumnaIzquierda from '../components/ColumnaIzquierda.vue';
import GenerarContenido from '../components/GenerarContenido.vue';
export default {
    name: 'GenerateContent',
    components: {
        ColumnaIzquierda,
        GenerarContenido,
    }
}
</script>